import { connect } from 'react-redux'

import { fetchQAServicing } from '../../actions/qa-servicings'
import QAServicingDetails from '../../components/qa-servicings/qa-servicing-details'

function mapStateToProps (state, ownProps) {
  const qaServicing = state.qaServicings[ownProps.params.qaServicingId]
  if (!qaServicing) return { loading: true }

  const area = state.areas[qaServicing.area]

  return {
    qaServicing,
    area
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchQAServicing(ownProps.params.qaServicingId))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QAServicingDetails)



// WEBPACK FOOTER //
// ./src/containers/qa-servicings/qa-servicing-details-container.js